"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.ButtonContainer = styled_components_1.default.button.attrs(function (props) { return ({
    disabled: props.disabled,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  min-width: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  border: ", ";\n  background-color: ", ";\n  color: ", ";\n  border-radius: 5px;\n  transition: all 0.3s;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    cursor: pointer;\n  }\n\n  &:active {\n    outline: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:disabled,\n  &[disabled] {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  min-width: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  border: ", ";\n  background-color: ", ";\n  color: ", ";\n  border-radius: 5px;\n  transition: all 0.3s;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ",
    ";\n    color: ", ";\n    cursor: pointer;\n  }\n\n  &:active {\n    outline: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:disabled,\n  &[disabled] {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n"])), function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.padding;
}, function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.minWidth;
}, function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.fontSize;
}, function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.border;
}, function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.backgroundColor;
}, function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.color;
}, function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.backgroundColorOnHover;
}, function (_a) {
    var variantStyle = _a.variantStyle;
    return variantStyle.colorOnHover;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map